import script from "./base-lazy-throughput.vue?vue&type=script&lang=ts"
export * from "./base-lazy-throughput.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__